<div class="scroll-to-top" *ngIf="navigationService.scrollToTopButton" (click)="scrollIntoView()">
  <img src="../../../assets/img/icon/scroll-to-top.svg" alt="icon">
</div>
